import apiUrl from '../../../constants'
import user_tracker from '../../../usertracker'
import axios from 'axios'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import download from 'downloadjs';
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'processcode-generation',
  components: {
    moment,
    download,
    VueElementLoading
  },
  props: [],
  data() {
    return {
      routemode: '',
      routemodeErr: '',
      PincodeData: [],
      csvFields: [],
      logDetails: [],
      isLoadingSearch: false
    }
  },
  computed: {},
  mounted() {
    var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    // user_tracker.checkUserIP(userdetail[0], "ProcessCodeGeneration", this.$route.path);

    this.getPinCodeLogDetails();
  },
  methods: {
    jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
      var csvData = ''
      //Header
      if (this.title != null) {
        csvData += this.parseExtraData(this.title, '${data}\r\n')
      }
      //Fields
      for (let key in data[0]) {
        if (skipFilter.indexOf(key) == -1)
          csvData += csvfield[key] + ','
      }
      csvData = csvData.slice(0, csvData.length - 1)
      csvData += '\r\n'
      //Data
      data.map(function(item) {
        for (let key in item) {
          if (skipFilter.indexOf(key) == -1) {
            var escapedCSV = item[key] + '' // cast Numbers to string
            if (escapedCSV.match(/[,"\n]/)) {
              escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
            }
            if (escapedCSV == 'null')
              csvData += ',';
            else {
              if (dateFilder.indexOf(key) != -1)
                csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
              else
                csvData += escapedCSV + ','
            }
          }
        }
        csvData = csvData.slice(0, csvData.length - 1)
        csvData += '\r\n'
      })
      //Footer
      if (this.footer != null) {
        csvData += this.parseExtraData(this.footer, '${data}\r\n')
      }
      filename += moment().format('DD-MM-YYYY') + '.csv';
      return this.export(csvData, filename, "application/csv");
      return csvData
    },
    export (data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
    },
    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },
    clearRouteModeErr() {
      if (this.routemode == '') {
        this.routemodeErr = "The Route Mode field is required."
      } else {
        this.routemodeErr = ""
      }
    },
    clearError(){
      this.routemode = ""
      this.routemodeErr = ""
    },
    getPincodeDetails() {
      if (this.routemode == '') {
        this.routemodeErr = "The Route Mode field is required."
        return false;
      } else {
        this.isLoadingSearch = true;
        this.routemodeErr = ""
        this.input = ({
          "mode": this.routemode
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'getPincodeRoute',
            'data': this.input,
            'headers': {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then(result => {
            this.isLoadingSearch = false;
            if (result.data.ResultCode == 100) {
              this.PincodeData = result.data.ResponseData
              this.csvFields = {
                'HubZoneName': 'HubZoneName',
                'GroupTitle': 'GroupTitle',
                'GroupName': 'GroupName',
                'ShipmentDestination': 'ShipmentDestination',
                'Pincode': 'Pincode',
                'Processcode': 'Processcode'
              }
              if (this.routemode == "Surface") {
                this.jsonToCSV('Surface_PincodeRouteReport_', this.PincodeData, this.csvFields);
              } else if (this.routemode == "Air") {
                this.jsonToCSV('Air_PincodeRouteReport_', this.PincodeData, this.csvFields);
              }
            } else {
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            this.isLoadingSearch = false;
            console.error(error)
          })
      }
    },

    getPinCodeLogDetails(){
			this.logDetails=[]; this.isLoadingSearch = true;
			this.input = ({});

			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'getProcessCodeLogPincodes',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(async result => {
					this.isLoadingSearch = false;

					if (result.data.ResultCode == 100) {

						this.logDetails = result.data.ResponseData;
            console.log(this.logDetails);
						this.$alertify.success(result.data.ReturnMessage);
					} else {

						this.$alertify.error(result.data.ReturnMessage);
					}
				}, error => {
					this.isLoadingSearch = false; console.error(error);
				})
		},

    getLogCSV(){
      this.isLoadingSearch = true;
			this.csvData=[]
      this.logDetails.map(item=>{
        this.csvData.push({
          PinCode: item.pincode,
          HubID:item.hubid,
          HubName:item.hubname,
          HubZoneName: item.hubzonename
        })
      })

			this.csvFields = {
				'PinCode': 'PinCode',
				'HubID': 'HubID',
				'HubName': 'HubName',
				'HubZoneName': 'HubZoneName'
			}
			this.jsonToCSV('NotGeneratedPCPincodes_', this.csvData, this.csvFields);
      this.isLoadingSearch = false;
		},
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ProcesscodeGeneration/ProcesscodeGeneration.js